import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { FetchTrainerPackagesArgs } from '../api/trainerSessions.api';

import { fetchTrainerPackages } from '../api/trainerSessions.api';

export const trainerSessionsQueryKeys = createQueryKeys('trainerSessions', {
  fetchTrainerPackages: (args: FetchTrainerPackagesArgs) => ({
    queryFn: () => fetchTrainerPackages(args),
    queryKey: [args.organizationId, args.clientId, args.assignedByTrainerId],
  }),
});
